import React from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  ${props =>
    props.indent &&
    css`
      margin-top: -200px;
      margin-bottom: 60px;

      @media (max-width: 860px) {
        margin-top: -100px;
        margin-bottom: 40px;
      }

      @media (max-width: 480px) {
        margin-top: -50px;
      }
    `}
  ${props =>
    props.indentBottom &&
    css`
      margin-bottom: -82px;
    `}
`

const CardImg = styled.img`
  display: block;
  margin: 0 auto;

  ${props =>
    props.rotate &&
    css`
      transform: rotate(${props.rotate});
    `}

  @media (max-width: 860px) {
    max-width: 100%;
    height: auto;

    ${props =>
      props.mobileMaxWidth &&
      css`
        max-width: ${props.mobileMaxWidth};
      `}
  }
`

const Card = ({ image, indent, indentBottom, rotate, mobileMaxWidth }) => (
  <Wrapper indent={indent} indentBottom={indentBottom}>
    <CardImg
      src={image.src}
      srcSet={image.srcSet}
      alt=""
      rotate={rotate}
      mobileMaxWidth={mobileMaxWidth}
    />
  </Wrapper>
)

export default Card
